import { MemberDatasource } from '../../global/datasources/member_datasource';
import { ICommand, IQuery, IDefineCommand } from 'core-ts-types';

angular.module('capability-ng-user-app').factory(
  'initializeGoogleTagManagerCommand',
  (ngMemberDatasource: MemberDatasource, defineCommand: IDefineCommand, $document: ng.IDocumentService): ICommand => {
    return defineCommand('initializeGoogleTagManagerCommand', function initializeGoogleTagManagerCommand(
      deferred: ng.IDeferred<IQuery[]>
    ): void {
      const head = $document.find('head')[0];

      const google_tag_manager = ngMemberDatasource.read().google_tag_manager;
      if (google_tag_manager.is_enabled && google_tag_manager.id) {
        const script = document.createElement('script');
        script.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer', '${google_tag_manager.id}');`;

        head.appendChild(script);
      }
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/user_app/commands/initialize_google_tag_manager_command.ts